module.exports = __webpack_public_path__ + "static/media/pg01.90acaa53.jpg";